export const GET_ASSIGNED_ALERTS_REQUEST = 'GET_ASSIGNED_ALERTS_REQUEST';
export const GET_ASSIGNED_ALERTS_SUCCESS = 'GET_ASSIGNED_ALERTS_SUCCESS';
export const GET_ASSIGNED_ALERTS_ERROR = 'GET_ASSIGNED_ALERTS_ERROR';
export const CREATE_ALERT_PERSONA_REQUEST = 'CREATE_ALERT_PERSONA_REQUEST';
export const CREATE_ALERT_PERSONA_SUCCESS = 'CREATE_ALERT_PERSONA_SUCCESS';
export const CREATE_ALERT_PERSONA_ERROR = 'CREATE_ALERT_PERSONA_ERROR';
export const UPDATE_ALERT_PERSONA_REQUEST = 'UPDATE_ALERT_PERSONA_REQUEST';
export const UPDATE_ALERT_PERSONA_SUCCESS = 'UPDATE_ALERT_PERSONA_SUCCESS';
export const UPDATE_ALERT_PERSONA_ERROR = 'UPDATE_ALERT_PERSONA_ERROR';
export const UPDATE_ALERT_PERSONA_RECIPIENT_REQUEST =
  'UPDATE_ALERT_PERSONA_RECIPIENT_REQUEST';
export const UPDATE_ALERT_PERSONA_RECIPIENT_SUCCESS =
  'UPDATE_ALERT_PERSONA_RECIPIENT_SUCCESS';
export const UPDATE_ALERT_PERSONA_RECIPIENT_ERROR =
  'UPDATE_ALERT_PERSONA_RECIPIENT_ERROR';
export const GET_ALERT_MACHINES_REQUEST = 'GET_ALERT_MACHINES_REQUEST';
export const GET_ALERT_MACHINES_SUCCESS = 'GET_ALERT_MACHINES_SUCCESS';
export const GET_ALERT_MACHINES_ERROR = 'GET_ALERT_MACHINES_ERROR';
export const UPDATE_ALERT_MACHINE_REQUEST = 'UPDATE_ALERT_MACHINE_REQUEST';
export const UPDATE_ALERT_MACHINE_SUCCESS = 'UPDATE_ALERT_MACHINE_SUCCESS';
export const UPDATE_ALERT_MACHINE_ERROR = 'UPDATE_ALERT_MACHINE_ERROR';
export const UPDATE_ACTIVE_DROPDOWN = 'UPDATE_ACTIVE_DROPDOWN';
export const DELETE_ALERT_PERSONA_REQUEST = 'DELETE_ALERT_PERSONA_REQUEST';
export const DELETE_ALERT_PERSONA_SUCCESS = 'DELETE_ALERT_PERSONA_SUCCESS';
export const DELETE_ALERT_PERSONA_ERROR = 'DELETE_ALERT_PERSONA_ERROR';
